export const getUserDataToken = () => {
    const userData = localStorage.getItem('user');
    if (userData !== null) {
        const tokenJson = JSON.parse(userData);
        if (tokenJson && tokenJson.token) {
            return tokenJson.token;
        }
    }
    return null;
};

export const getOpenUserData = () => {
    const store = localStorage.getItem('user');
    if (store !== null) {
        const data = JSON.parse(store);
        if (data && data.email) {
            return data.email;
        }
    }
    return null;
};
